/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BackendTypesEnum } from './BackendTypesEnum';
import {
    BackendTypesEnumFromJSON,
    BackendTypesEnumFromJSONTyped,
    BackendTypesEnumToJSON,
} from './BackendTypesEnum';
import type { ClusterStateEnum } from './ClusterStateEnum';
import {
    ClusterStateEnumFromJSON,
    ClusterStateEnumFromJSONTyped,
    ClusterStateEnumToJSON,
} from './ClusterStateEnum';
import type { ClusterTag } from './ClusterTag';
import {
    ClusterTagFromJSON,
    ClusterTagFromJSONTyped,
    ClusterTagToJSON,
} from './ClusterTag';
import type { ClusterTypeEnum } from './ClusterTypeEnum';
import {
    ClusterTypeEnumFromJSON,
    ClusterTypeEnumFromJSONTyped,
    ClusterTypeEnumToJSON,
} from './ClusterTypeEnum';
import type { CustomGroupSchema } from './CustomGroupSchema';
import {
    CustomGroupSchemaFromJSON,
    CustomGroupSchemaFromJSONTyped,
    CustomGroupSchemaToJSON,
} from './CustomGroupSchema';
import type { MetricFlag } from './MetricFlag';
import {
    MetricFlagFromJSON,
    MetricFlagFromJSONTyped,
    MetricFlagToJSON,
} from './MetricFlag';
import type { ProcessStateEnum } from './ProcessStateEnum';
import {
    ProcessStateEnumFromJSON,
    ProcessStateEnumFromJSONTyped,
    ProcessStateEnumToJSON,
} from './ProcessStateEnum';
import type { TagAlertHitSchema } from './TagAlertHitSchema';
import {
    TagAlertHitSchemaFromJSON,
    TagAlertHitSchemaFromJSONTyped,
    TagAlertHitSchemaToJSON,
} from './TagAlertHitSchema';
import type { WorkerByTypeSchema } from './WorkerByTypeSchema';
import {
    WorkerByTypeSchemaFromJSON,
    WorkerByTypeSchemaFromJSONTyped,
    WorkerByTypeSchemaToJSON,
} from './WorkerByTypeSchema';

/**
 * 
 * @export
 * @interface ListClusterV2
 */
export interface ListClusterV2 {
    /**
     * 
     * @type {number}
     * @memberof ListClusterV2
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ListClusterV2
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ListClusterV2
     */
    accountSlug: string;
    /**
     * 
     * @type {string}
     * @memberof ListClusterV2
     */
    accountName: string;
    /**
     * 
     * @type {number}
     * @memberof ListClusterV2
     */
    accountId: number;
    /**
     * 
     * @type {string}
     * @memberof ListClusterV2
     */
    creatorUsername: string;
    /**
     * 
     * @type {number}
     * @memberof ListClusterV2
     */
    creatorId: number;
    /**
     * 
     * @type {ClusterStateEnum}
     * @memberof ListClusterV2
     */
    state: ClusterStateEnum;
    /**
     * 
     * @type {string}
     * @memberof ListClusterV2
     */
    reason: string;
    /**
     * 
     * @type {boolean}
     * @memberof ListClusterV2
     */
    staffHasSeen: boolean;
    /**
     * 
     * @type {string}
     * @memberof ListClusterV2
     */
    organizationFeatureTier?: string;
    /**
     * 
     * @type {BackendTypesEnum}
     * @memberof ListClusterV2
     */
    backendType: BackendTypesEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ListClusterV2
     */
    coiledHosted: boolean;
    /**
     * 
     * @type {number}
     * @memberof ListClusterV2
     */
    senvAliasId?: number;
    /**
     * 
     * @type {number}
     * @memberof ListClusterV2
     */
    senvBuildId?: number;
    /**
     * 
     * @type {string}
     * @memberof ListClusterV2
     */
    softwareEnvironmentName?: string;
    /**
     * 
     * @type {ProcessStateEnum}
     * @memberof ListClusterV2
     */
    schedulerState: ProcessStateEnum;
    /**
     * 
     * @type {string}
     * @memberof ListClusterV2
     */
    workerAcceleratorType?: string;
    /**
     * 
     * @type {number}
     * @memberof ListClusterV2
     */
    workerAcceleratorCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ListClusterV2
     */
    desiredWorkers: number;
    /**
     * 
     * @type {number}
     * @memberof ListClusterV2
     */
    runningWorkers: number;
    /**
     * 
     * @type {number}
     * @memberof ListClusterV2
     */
    totalWorkers: number;
    /**
     * 
     * @type {string}
     * @memberof ListClusterV2
     */
    regionName?: string;
    /**
     * 
     * @type {Array<WorkerByTypeSchema>}
     * @memberof ListClusterV2
     */
    workerTypes: Array<WorkerByTypeSchema>;
    /**
     * 
     * @type {string}
     * @memberof ListClusterV2
     */
    dashboardAddress?: string;
    /**
     * 
     * @type {number}
     * @memberof ListClusterV2
     */
    nTasks?: number;
    /**
     * 
     * @type {Array<ClusterTag>}
     * @memberof ListClusterV2
     */
    tagList: Array<ClusterTag>;
    /**
     * 
     * @type {Array<TagAlertHitSchema>}
     * @memberof ListClusterV2
     */
    alertList: Array<TagAlertHitSchema>;
    /**
     * 
     * @type {Array<MetricFlag>}
     * @memberof ListClusterV2
     */
    metricFlags: Array<MetricFlag>;
    /**
     * 
     * @type {number}
     * @memberof ListClusterV2
     */
    costPerHour?: number;
    /**
     * 
     * @type {number}
     * @memberof ListClusterV2
     */
    totalCost?: number;
    /**
     * 
     * @type {Date}
     * @memberof ListClusterV2
     */
    lastSeen?: Date;
    /**
     * 
     * @type {number}
     * @memberof ListClusterV2
     */
    billableTime?: number;
    /**
     * 
     * @type {number}
     * @memberof ListClusterV2
     */
    approximateCloudCostPerHour?: number;
    /**
     * 
     * @type {number}
     * @memberof ListClusterV2
     */
    approximateCloudTotalCost?: number;
    /**
     * 
     * @type {number}
     * @memberof ListClusterV2
     */
    approximateCloudCostVersion: number;
    /**
     * 
     * @type {CustomGroupSchema}
     * @memberof ListClusterV2
     */
    dealStageGroup?: CustomGroupSchema;
    /**
     * 
     * @type {boolean}
     * @memberof ListClusterV2
     */
    pauseOnExit?: boolean;
    /**
     * 
     * @type {ClusterTypeEnum}
     * @memberof ListClusterV2
     */
    clusterType?: ClusterTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ListClusterV2
     */
    privateToCreator: boolean;
}

/**
 * Check if a given object implements the ListClusterV2 interface.
 */
export function instanceOfListClusterV2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "accountSlug" in value;
    isInstance = isInstance && "accountName" in value;
    isInstance = isInstance && "accountId" in value;
    isInstance = isInstance && "creatorUsername" in value;
    isInstance = isInstance && "creatorId" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "reason" in value;
    isInstance = isInstance && "staffHasSeen" in value;
    isInstance = isInstance && "backendType" in value;
    isInstance = isInstance && "coiledHosted" in value;
    isInstance = isInstance && "schedulerState" in value;
    isInstance = isInstance && "desiredWorkers" in value;
    isInstance = isInstance && "runningWorkers" in value;
    isInstance = isInstance && "totalWorkers" in value;
    isInstance = isInstance && "workerTypes" in value;
    isInstance = isInstance && "tagList" in value;
    isInstance = isInstance && "alertList" in value;
    isInstance = isInstance && "metricFlags" in value;
    isInstance = isInstance && "approximateCloudCostVersion" in value;
    isInstance = isInstance && "privateToCreator" in value;

    return isInstance;
}

export function ListClusterV2FromJSON(json: any): ListClusterV2 {
    return ListClusterV2FromJSONTyped(json, false);
}

export function ListClusterV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ListClusterV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'accountSlug': json['account_slug'],
        'accountName': json['account_name'],
        'accountId': json['account_id'],
        'creatorUsername': json['creator_username'],
        'creatorId': json['creator_id'],
        'state': ClusterStateEnumFromJSON(json['state']),
        'reason': json['reason'],
        'staffHasSeen': json['staff_has_seen'],
        'organizationFeatureTier': !exists(json, 'organization_feature_tier') ? undefined : json['organization_feature_tier'],
        'backendType': BackendTypesEnumFromJSON(json['backend_type']),
        'coiledHosted': json['coiled_hosted'],
        'senvAliasId': !exists(json, 'senv_alias_id') ? undefined : json['senv_alias_id'],
        'senvBuildId': !exists(json, 'senv_build_id') ? undefined : json['senv_build_id'],
        'softwareEnvironmentName': !exists(json, 'software_environment_name') ? undefined : json['software_environment_name'],
        'schedulerState': ProcessStateEnumFromJSON(json['scheduler_state']),
        'workerAcceleratorType': !exists(json, 'worker_accelerator_type') ? undefined : json['worker_accelerator_type'],
        'workerAcceleratorCount': !exists(json, 'worker_accelerator_count') ? undefined : json['worker_accelerator_count'],
        'desiredWorkers': json['desired_workers'],
        'runningWorkers': json['running_workers'],
        'totalWorkers': json['total_workers'],
        'regionName': !exists(json, 'region_name') ? undefined : json['region_name'],
        'workerTypes': ((json['worker_types'] as Array<any>).map(WorkerByTypeSchemaFromJSON)),
        'dashboardAddress': !exists(json, 'dashboard_address') ? undefined : json['dashboard_address'],
        'nTasks': !exists(json, 'n_tasks') ? undefined : json['n_tasks'],
        'tagList': ((json['tag_list'] as Array<any>).map(ClusterTagFromJSON)),
        'alertList': ((json['alert_list'] as Array<any>).map(TagAlertHitSchemaFromJSON)),
        'metricFlags': ((json['metric_flags'] as Array<any>).map(MetricFlagFromJSON)),
        'costPerHour': !exists(json, 'cost_per_hour') ? undefined : json['cost_per_hour'],
        'totalCost': !exists(json, 'total_cost') ? undefined : json['total_cost'],
        'lastSeen': !exists(json, 'last_seen') ? undefined : (new Date(json['last_seen'])),
        'billableTime': !exists(json, 'billable_time') ? undefined : json['billable_time'],
        'approximateCloudCostPerHour': !exists(json, 'approximate_cloud_cost_per_hour') ? undefined : json['approximate_cloud_cost_per_hour'],
        'approximateCloudTotalCost': !exists(json, 'approximate_cloud_total_cost') ? undefined : json['approximate_cloud_total_cost'],
        'approximateCloudCostVersion': json['approximate_cloud_cost_version'],
        'dealStageGroup': !exists(json, 'deal_stage_group') ? undefined : CustomGroupSchemaFromJSON(json['deal_stage_group']),
        'pauseOnExit': !exists(json, 'pause_on_exit') ? undefined : json['pause_on_exit'],
        'clusterType': !exists(json, 'cluster_type') ? undefined : ClusterTypeEnumFromJSON(json['cluster_type']),
        'privateToCreator': json['private_to_creator'],
    };
}

export function ListClusterV2ToJSON(value?: ListClusterV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'account_slug': value.accountSlug,
        'account_name': value.accountName,
        'account_id': value.accountId,
        'creator_username': value.creatorUsername,
        'creator_id': value.creatorId,
        'state': ClusterStateEnumToJSON(value.state),
        'reason': value.reason,
        'staff_has_seen': value.staffHasSeen,
        'organization_feature_tier': value.organizationFeatureTier,
        'backend_type': BackendTypesEnumToJSON(value.backendType),
        'coiled_hosted': value.coiledHosted,
        'senv_alias_id': value.senvAliasId,
        'senv_build_id': value.senvBuildId,
        'software_environment_name': value.softwareEnvironmentName,
        'scheduler_state': ProcessStateEnumToJSON(value.schedulerState),
        'worker_accelerator_type': value.workerAcceleratorType,
        'worker_accelerator_count': value.workerAcceleratorCount,
        'desired_workers': value.desiredWorkers,
        'running_workers': value.runningWorkers,
        'total_workers': value.totalWorkers,
        'region_name': value.regionName,
        'worker_types': ((value.workerTypes as Array<any>).map(WorkerByTypeSchemaToJSON)),
        'dashboard_address': value.dashboardAddress,
        'n_tasks': value.nTasks,
        'tag_list': ((value.tagList as Array<any>).map(ClusterTagToJSON)),
        'alert_list': ((value.alertList as Array<any>).map(TagAlertHitSchemaToJSON)),
        'metric_flags': ((value.metricFlags as Array<any>).map(MetricFlagToJSON)),
        'cost_per_hour': value.costPerHour,
        'total_cost': value.totalCost,
        'last_seen': value.lastSeen === undefined ? undefined : (value.lastSeen.toISOString()),
        'billable_time': value.billableTime,
        'approximate_cloud_cost_per_hour': value.approximateCloudCostPerHour,
        'approximate_cloud_total_cost': value.approximateCloudTotalCost,
        'approximate_cloud_cost_version': value.approximateCloudCostVersion,
        'deal_stage_group': CustomGroupSchemaToJSON(value.dealStageGroup),
        'pause_on_exit': value.pauseOnExit,
        'cluster_type': ClusterTypeEnumToJSON(value.clusterType),
        'private_to_creator': value.privateToCreator,
    };
}

